const HeroAria = () => {
  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="hero-content">
              <h1>
               Vision Workspaces
              </h1>
              <h3>my Vision, my Space</h3>
              <p>
                A bright, serene space that fosters positivity, growth, and success. Here, ideas thrive, and ambitions take shape.
              </p>
                <a className="whatsapp-btn"
                    href="https://wa.me/919082667792" target="_blank"
                  >
                    <i className="fa fa-whatsapp" aria-hidden="true" />Whatsapp
                  </a>
              {/* <div className="hero-video-player">
                <div className="hero-video-player-icon">
                  <a className=""
                    href="https://wa.me/919082667792" target="_blank"
                  >
                    <i className="fa fa-whatsapp" aria-hidden="true" />Whatsapp
                  </a>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default HeroAria;